import React from 'react';
import { ALERT_SHOW, ALERT_SET_MESSAGE } from '../actions/alert/constants';

const initialState = {
  show: false,
  message: <></>,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ALERT_SHOW:
      return { ...state, show: action.payload };
    case ALERT_SET_MESSAGE:
      return { ...state, message: action.payload };
    default:
      return state;
  }
};
